import { render, staticRenderFns } from "./OutstandingInsurer.vue?vue&type=template&id=44229eca"
import script from "./OutstandingInsurer.vue?vue&type=script&lang=js"
export * from "./OutstandingInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports